module.exports = __webpack_public_path__ + "static/media/Prev_Ques_Arrow.4549c5c8.svg";